const CARRIER_LABEL_MODULE_BY_ID: Record<string, LabelModuleType> = {
  '1': 'colissimo',
  '3': 'freeShipping',
  '10': 'dpd',
  '19': 'ups',
}

export const GPX_CARRIER_IDS = ['6', '11', '2649', '2915'] as const

export function isGpxCarrier(
  idLivraison: number | string | null | undefined
): boolean {
  if (idLivraison == null) return false
  return (GPX_CARRIER_IDS as readonly string[]).includes(String(idLivraison))
}

export type LabelModuleType =
  | 'colissimo'
  | 'dpd'
  | 'ups'
  | 'easy'
  | 'freeShipping'

/**
 * Détermine quel module d'étiquette utiliser selon l'ID de livraison
 * 
 * @param idLivraison ID de la livraison
 * @returns Le type de module à utiliser
 */
export function getLabelModule(
  idLivraison: number | null | undefined
): LabelModuleType | null {
  if (!idLivraison) return null

  const idLivraisonStr = idLivraison.toString()

  // Retrait en magasin: pas de module d'étiquette
  if (idLivraisonStr === '2') {
    return null
  }

  return CARRIER_LABEL_MODULE_BY_ID[idLivraisonStr] || 'easy'
}
